import React, { FunctionComponent } from 'react';
import { Box, Flex } from '@rebass/emotion';
import s37Logo from '@images/science37-dark.png';
import { css } from '@emotion/core';

interface HeaderProps {
  mq(params: any): any;
  strings: {
    phone: string;
    email: string;
  };
}

const Header: FunctionComponent<HeaderProps> = ({ mq, strings: { phone, email } }) => {
  return (
    <Box
      id="header"
      bg="#e9e9e9"
      height={['40px', '60px', '60px', '60px']}
      position={['relative']}
      width={['100vw']}
      p={['8px 0']}
    >
      <Box maxWidth={['100%', '90%', '80%', '1170px']} width="100%" pr="15px" pl="15px" mr="auto" ml="auto">
        <Flex
          flexWrap="wrap"
          css={mq({
            marginLeft: ['', '', '-15px', '-15px'],
            marginRight: ['', '', '-15px', '-15px'],
          })}
        >
          <Box
            maxWidth={['34%', '34%', '50%', '50%']}
            flex={['0 0 34%', '0 0 33.333333%', '0 0 50%', '0 0 50%']}
            pr="15px"
            pl="15px"
          >
            <a href="/">
              <img
                src={s37Logo}
                alt="Science 37"
                css={mq({
                  width: ['80px', '140px', '140px', '140px'],
                })}
                style={{ verticalAlign: 'middle', borderStyle: 'none' }}
              />
            </a>
          </Box>
          <Box
            maxWidth={['66%', '66%', '50%', '50%']}
            flex={['0 0 66%', '0 0 66.666667%', '0 0 50%', '0 0 50%']}
            pr="15px"
            pl="15px"
            css={css`
              position: relative;
            `}
          >
            <Box
              color="#333f48"
              textAlign="right"
              css={css`
                margin: 0;
                position: absolute;
                top: 50%;
                -ms-transform: translateY(-50%);
                transform: translateY(-50%);
                right: 20px;
              `}
              fontSize={['10px', '12px', '16px', '16px']}
            >
              <span style={{ fontWeight: 'bold', color: '#6cc24a', textTransform: 'uppercase' }}>Have Questions: </span>
              <a style={{ color: '#333f48', textDecoration: 'none' }} href={`tel:${phone}`}>
                {phone}
              </a>
              &nbsp;or&nbsp;
              <a style={{ color: '#333f48', textDecoration: 'none' }} href={`mailto:${email}`}>
                {email}
              </a>
            </Box>
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};

export { Header };
